var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-root"},[(_vm.isLoading)?_c('b-spinner',{staticClass:"d-block mx-auto text-primary my-2"}):_c('auth-layout',{attrs:{"community":_vm.community,"auth-api-url":_vm.authApiUrl}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }